import * as Scrivito from 'scrivito';

Scrivito.provideObjClass('Download', {
  attributes: {
    blob: 'binary',
  },
});
